import { useState, useEffect } from "react";
import { addPractitionersAPI, getGroupsAPI, editGroupAPI, removePractitionersAPI, addPatientsAPI, removePatientAPI, getPatientsInGroupAPI, getPractitionersInGroupAPI, addPatientToPractitionerAPI, updatePractitionerPatientAssignmentsApi, reasignPatientsApi, removeAllPatientsAPI, removeAllPractitionersAPI } from "../../../api/protocolGroups";
import { HandleApiError } from "../../../components/Notifications/APIErrorHandler";

export const useGroups = () => {
    const [isLoading, setIsLoading] = useState(true);

    const getGroups = async () => {
        try {
            return getGroupsAPI();
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            return null;
        }
    }

    const editGroup = async (groupId, groupData) => {

        let protocolIds = [];

        //si se modifican los protocolos groupsProtocols viene de una manera y sino viene de otra
        if (groupData.groupsProtocols && Array.isArray(groupData.groupsProtocols)) {
            protocolIds = groupData.groupsProtocols.map(item => {
                return item.protocol ? item.protocol.id : item.id;
            });
        }
        const payload = {
            name: groupData.name,
            description: groupData.description,
            patientLimit: groupData.patientLimit,
            groupPatientLimit: groupData.groupPatientLimit,
            specialties: groupData.groupsSpecialties ? groupData.groupsSpecialties : [],
            protocolIds: protocolIds,
        };

        try {
            return await editGroupAPI(groupId, payload);
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            throw error; // Re-lanzo para que el caller tome la rama de error (ver mismo fix en addPatients).
        }
    }

    /*   const getNote = async (protocolId, noteId) => {
           try {
               setIsLoading(true);
               const note = await getMonitorNote(protocolId, noteId);
               setIsLoading(false);
   
               return note;
   
           } catch (error) {
               HandleApiError(error);
               setIsLoading(false);
   
               return null;
           }
       }
   
       const createNote = async (type, documentId, protocolId, visitId, patientId, note) => {
           try {
               setIsLoading(true);
               const documentNote = await createMonitorNote(documentId, protocolId, visitId, patientId, { note: note, type: type });
               setIsLoading(false);
   
               return documentNote;
   
           } catch (error) {
               HandleApiError(error);
               setIsLoading(false);
   
               return null;
           }
       }
   
       const updateNote = async (protocolId, noteId, note) => {
           try {
               setIsLoading(true);
               const documentNote = await updateMonitorNote(protocolId, noteId, { note: note });
               setIsLoading(false);
   
               return documentNote;
   
           } catch (error) {
               HandleApiError(error);
               setIsLoading(false);
   
               return null;
           }
       }
   
       const changeStatusNote = async (protocolId, noteId, status, response) => {
           try {
               setIsLoading(true);
               const documentNote = await changeStatusMonitorNote(protocolId, noteId, { status: status, response: response });
               setIsLoading(false);
   
               return documentNote;
   
           } catch (error) {
               HandleApiError(error);
               setIsLoading(false);
   
               return null;
           }
       }
   
       const deleteNote = async (protocolId, noteId) => {
           try {
               setIsLoading(true);
               var res = await removeMonitorNote(protocolId, noteId);
               setIsLoading(false);
   
               return res;
   
           } catch (error) {
               HandleApiError(error);
               setIsLoading(false);
   
               return null;
           }
       }
   */
    return [isLoading, getGroups, editGroup];
}

export const useGroupPatients = (groupId, protocolId) => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [totalSize, setTotalSize] = useState(0);
    const [query, setQuery] = useState({
        pagination: {
            page: 1,
            sizePerPage: 10,
            totalSize: 0
        },
        sort: {
            sortField: "Start",
            sortOrder: "desc"
        },
        filters: {
            AssignmentStatus: 0,
            FullName: null,
            practitionerId: null,
            protocolId: protocolId?.protocolId,
        }
    });
    
    useEffect(() => {
        let isSubscribed = true;

        const fetchData = () => {
            setIsLoading(true);

            getPatientsInGroupAPI(groupId, query)
                .then(response => {
                    if (isSubscribed) {
                        const paginatedResult = response.data;

                        setTotalSize(paginatedResult.count);
                        setData(paginatedResult.data);
                        setIsLoading(false);
                    }
                }).catch(error => {
                    if (isSubscribed) {
                        HandleApiError(error);
                        setIsLoading(false);
                    }
                });
        }

        fetchData();
        
        return () => isSubscribed = false;
    }, [query]);

    const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
       
        var newQuery = null;
        if (type === 'pagination') {
            newQuery = JSON.parse(JSON.stringify(query));

            newQuery.pagination.page = page;
            newQuery.pagination.sizePerPage = sizePerPage;
            setQuery(newQuery);
        }

        if (type === 'sort') {
            newQuery = JSON.parse(JSON.stringify(query));

            newQuery.sort.sortField = sortField;
            newQuery.sort.sortOrder = sortOrder;

            setQuery(newQuery);
        }

        if (type === 'reload') {
            newQuery = JSON.parse(JSON.stringify(query));
            setQuery(newQuery);
        }
    }

    const addPatients = async (patients) => {
        try {
            return await addPatientsAPI(groupId, patients);
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            throw error; // Re-lanzo para que el caller (confirmPatient) tome la rama de error y no dispare Success/updateGroup.
        }
    }

    const removePatient = async (patientId) => {
        try {
            return removePatientAPI(groupId, patientId);
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            return null;
        }
    }

    const addPatientToPractitioner = async (patientId, practitionerId) => {
        try {
            return addPatientToPractitionerAPI(groupId, patientId, practitionerId);
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            return null;
        }
    }
    
    const handleFilterChange = (filterName, selectedValue) => {

        if (filterName) {
            var newQuery = JSON.parse(JSON.stringify(query));
            
            if (filterName === "AssignmentStatus") {
                newQuery.filters[filterName] = selectedValue != null ? selectedValue.id : selectedValue;
                setQuery(newQuery);
            }        
            if (filterName === "FullName") {
                newQuery.filters[filterName] = selectedValue;
                setQuery(newQuery);
            }
            if (filterName === "protocolIds") {
                newQuery.filters["protocolId"] = selectedValue;
                setQuery(newQuery);
            }
        }
        
    }

    const removeAllPatients = async () => {
        try {
            return removeAllPatientsAPI(groupId, query);
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            return null;
        }
    }

    return [data, query, totalSize, isLoading, addPatients, removePatient, handleTableChange, addPatientToPractitioner, handleFilterChange, removeAllPatients];
}

export const useGroupPatientsPractitioner = (groupId, protocolId) => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [totalSize, setTotalSize] = useState(0);
    const [query, setQuery] = useState({
        pagination: {
            page: 1,
            sizePerPage: 10,
            totalSize: 0
        },
        sort: {
            sortField: "Start",
            sortOrder: "desc"
        },
        filters: {
            AssignmentStatus: 0,
            FullName: null,
            practitionerId: null,
            protocolId: protocolId?.protocolId,
        }
    });

    useEffect(() => {
        let isSubscribed = true;

        const fetchData = () => {
            setIsLoading(true);
            getPatientsInGroupAPI(groupId, query)
                .then(response => {
                    if (isSubscribed) {
                        const paginatedResult = response.data;

                        setTotalSize(paginatedResult.count);
                        setData(paginatedResult.data);
                        setIsLoading(false);
                    }
                }).catch(error => {
                    if (isSubscribed) {
                        HandleApiError(error);
                        setIsLoading(false);
                    }
                });
        }

        fetchData();

        return () => isSubscribed = false;
    }, [query]);

    const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {

        var newQuery = null;
        if (type === 'pagination') {
            newQuery = JSON.parse(JSON.stringify(query));

            newQuery.pagination.page = page;
            newQuery.pagination.sizePerPage = sizePerPage;
            setQuery(newQuery);
        }

        if (type === 'sort') {
            newQuery = JSON.parse(JSON.stringify(query));

            newQuery.sort.sortField = sortField;
            newQuery.sort.sortOrder = sortOrder;

            setQuery(newQuery);
        }

        if (type === 'reload') {
            newQuery = JSON.parse(JSON.stringify(query));
            setQuery(newQuery);
        }
    }

    const updatePatientsPractitioner = async (practitionerId, newRelations) => {
        try {
            return updatePractitionerPatientAssignmentsApi(practitionerId, groupId, newRelations);
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            return null;
        }
    }

    //resete el query cuando se cierra un modal
    const handleQueryReset = () => {
        setQuery({
            pagination: { page: 1, sizePerPage: 10 },
            sort: {
                sortField: "Start",
                sortOrder: "desc"
            }, 
            filters: {
                AssignmentStatus: 0,
                FullName: null,
                practitionerId: null,
                protocolId: protocolId?.protocolId,
            } 
        });
    };

    const reasignPatients = async (oldPractitioner, newPractitioner, patientIds) => {
        try {
            return reasignPatientsApi(groupId, oldPractitioner, newPractitioner, patientIds)
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            return null;
        }
    }

    const handleFilterChange = (filterName, selectedValue, practitionerId) => {

        if (filterName) {
            var newQuery = JSON.parse(JSON.stringify(query));

            if (filterName === "AssignmentStatus") {
                newQuery.filters[filterName] = selectedValue != null ? selectedValue.id : selectedValue;
            }
            if (filterName === "FullName") {
                newQuery.filters[filterName] = selectedValue;
            }

            newQuery.filters["PractitionerId"] = practitionerId;
            setQuery(newQuery);
        }
    }
    
    return [data, query, totalSize, isLoading, handleTableChange, updatePatientsPractitioner, handleQueryReset, reasignPatients, handleFilterChange];
}

export const useGroupPractitioners = (groupId) => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [totalSize, setTotalSize] = useState(0);
    const [query, setQuery] = useState({
        pagination: {
            page: 1,
            sizePerPage: 10,
            totalSize: 0
        },
        sort: {
            sortField: "Start",
            sortOrder: "desc"
        },
        filters: {
            FullName: null
        }
    });

    useEffect(() => {
        let isSubscribed = true;

        const fetchData = () => {
            setIsLoading(true);
            getPractitionersInGroupAPI(groupId, query)
                .then(response => {
                    if (isSubscribed) {
                        const paginatedResult = response.data;

                        setTotalSize(paginatedResult.count);
                        setData(paginatedResult.data);
                        setIsLoading(false);
                    }
                }).catch(error => {
                    if (isSubscribed) {
                        HandleApiError(error);
                        setIsLoading(false);
                    }
                });
        }

        fetchData();

        return () => isSubscribed = false;
    }, [query]);

    const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        var newQuery = null;
        if (type === 'pagination') {
            newQuery = JSON.parse(JSON.stringify(query));

            newQuery.pagination.page = page;
            newQuery.pagination.sizePerPage = sizePerPage;
            setQuery(newQuery);
        }

        if (type === 'sort') {
            newQuery = JSON.parse(JSON.stringify(query));

            newQuery.sort.sortField = sortField;
            newQuery.sort.sortOrder = sortOrder;

            setQuery(newQuery);
        }

        if (type === 'reload') {
            newQuery = JSON.parse(JSON.stringify(query));
            setQuery(newQuery);
        }
    }

    const addPractitioners = async (practitioners) => {
        try {
            return addPractitionersAPI(groupId, practitioners);
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            return null;
        }
    }

    const removePractitioner = async (practitionerId) => {
        try {
            return removePractitionersAPI(groupId, practitionerId);
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            return null;
        }
    }

    const handleFilterChange = (filterName, selectedValue) => {

        if (filterName === "userName") {
            var newQuery = JSON.parse(JSON.stringify(query));
            newQuery.filters[filterName] = selectedValue;
            setQuery(newQuery);
        }
    }
    

    const removeAllPractitioners = async () => {
        try {
            return removeAllPractitionersAPI(groupId, query);
        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            return null;
        }
    }

    /*   const getNote = async (protocolId, noteId) => {
           try {
               setIsLoading(true);
               const note = await getMonitorNote(protocolId, noteId);
               setIsLoading(false);
   
               return note;
   
           } catch (error) {
               HandleApiError(error);
               setIsLoading(false);
   
               return null;
           }
       }
   
       const createNote = async (type, documentId, protocolId, visitId, patientId, note) => {
           try {
               setIsLoading(true);
               const documentNote = await createMonitorNote(documentId, protocolId, visitId, patientId, { note: note, type: type });
               setIsLoading(false);
   
               return documentNote;
   
           } catch (error) {
               HandleApiError(error);
               setIsLoading(false);
   
               return null;
           }
       }
   
       const updateNote = async (protocolId, noteId, note) => {
           try {
               setIsLoading(true);
               const documentNote = await updateMonitorNote(protocolId, noteId, { note: note });
               setIsLoading(false);
   
               return documentNote;
   
           } catch (error) {
               HandleApiError(error);
               setIsLoading(false);
   
               return null;
           }
       }
   
       const changeStatusNote = async (protocolId, noteId, status, response) => {
           try {
               setIsLoading(true);
               const documentNote = await changeStatusMonitorNote(protocolId, noteId, { status: status, response: response });
               setIsLoading(false);
   
               return documentNote;
   
           } catch (error) {
               HandleApiError(error);
               setIsLoading(false);
   
               return null;
           }
       }
   
       const deleteNote = async (protocolId, noteId) => {
           try {
               setIsLoading(true);
               var res = await removeMonitorNote(protocolId, noteId);
               setIsLoading(false);
   
               return res;
   
           } catch (error) {
               HandleApiError(error);
               setIsLoading(false);
   
               return null;
           }
       }
   */
    return [data, query, totalSize, isLoading, addPractitioners, removePractitioner, handleTableChange, handleFilterChange, removeAllPractitioners];
}